import { Card } from "./ui/card";
import { MapPin, Sun, Camera } from "lucide-react";

const trips = [
  {
    title: "Beach Paradise",
    img: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=400&q=80",
    description: "Soak up the sun and waves at the world's most stunning beaches.",
    icon: Sun,
  },
  {
    title: "City Explorer",
    img: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?auto=format&fit=crop&w=400&q=80",
    description: "Discover vibrant cities, culture, and hidden gems around the globe.",
    icon: MapPin,
  },
  {
    title: "Nature Retreat",
    img: "https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=400&q=80",
    description: "Rejuvenate in breathtaking mountains and tranquil forests.",
    icon: Camera,
  },
];

const TripTemplates = () => (
  <section className="w-full max-w-5xl mx-auto px-4 py-8">
    <h2 className="text-2xl md:text-3xl font-bold text-slate-900 dark:text-white mb-8 text-center tracking-tight">
      Get Inspired by Trending Trips
    </h2>
    <div className="grid gap-8 md:grid-cols-3 sm:grid-cols-2 grid-cols-1">
      {trips.map(({ title, img, description, icon: Icon }) => (
        <Card
          key={title}
          className="backdrop-blur border-none shadow-2xl rounded-2xl overflow-hidden transition transform bg-white/60 dark:bg-slate-900/50 hover:scale-[1.03] hover:shadow-3xl group"
        >
          <div className="relative w-full h-48 md:h-40 bg-slate-100 dark:bg-slate-800">
            <img src={img} alt={title} className="w-full h-full object-cover object-center group-hover:scale-105 transition-all" />
            <span className="absolute top-3 right-3 bg-slate-50/80 dark:bg-slate-900/70 p-2 rounded-full shadow">
              <Icon className="w-6 h-6 text-sky-500" />
            </span>
          </div>
          <div className="p-6 flex flex-col items-center">
            <h3 className="font-semibold text-lg text-slate-800 dark:text-white mb-2 text-center">
              {title}
            </h3>
            <p className="text-slate-600 dark:text-slate-300 text-center text-sm mb-2">
              {description}
            </p>
          </div>
        </Card>
      ))}
    </div>
  </section>
);

export default TripTemplates;
